import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { TVehiculeCheckEmailSchema } from '@/schemas/vehicule-check-email/vehicule-check-email.schema';

const VEHICULE_CHECK_EMAIL_URI = '/vehiculeCheckEmail';

export const createNewVehiculeCheckEmail = async (
  vehiculeCheckEmail: TVehiculeCheckEmailSchema,
) => {
  return requestApi({
    url: VEHICULE_CHECK_EMAIL_URI,
    method: HTTP_METHOD.POST,
    body: vehiculeCheckEmail,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllVehiculeCheckEmails = async (
  filter: string,
  page: number,
  limit: number,
) => {
  return requestApi({
    url: `${VEHICULE_CHECK_EMAIL_URI}/all?key=${filter}&page=${page}&limit=${limit}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getEmailById = async (id: string) => {
  return requestApi({
    url: `${VEHICULE_CHECK_EMAIL_URI}/${id}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
